import { render, staticRenderFns } from "./BotonesSso.vue?vue&type=template&id=59b8a47c&scoped=true"
import script from "./BotonesSso.vue?vue&type=script&lang=js"
export * from "./BotonesSso.vue?vue&type=script&lang=js"
import style0 from "./BotonesSso.vue?vue&type=style&index=0&id=59b8a47c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b8a47c",
  null
  
)

export default component.exports